import { Box } from "@mui/material";
import { SecurityBadge } from "./securityBadge.component";

interface AuthCardProps {
  children: React.ReactNode;
}

export const AuthCard = ({ children }: AuthCardProps) => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "800px",
        mx: "auto",
        p: { xs: 2, sm: 3, md: 4 },
        borderRadius: 2,
        backgroundColor: "rgba(255, 255, 255, 0.03)",
        backdropFilter: "blur(16px)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        position: "relative",
        minHeight: { xs: "200px", sm: "300px" },
        mb: { xs: "120px", sm: "80px" },
      }}
    >
      {children}
      <SecurityBadge />
    </Box>
  );
};
